/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:59:58
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  rechargesList: {
    terms: {
      dateStart: null,
      dateEnd: null,
      sort: 'desc',
      sortBy: 'date',
    },
    data: [],
  },
};

const getters = {
  rechargesList: state => state.rechargesList,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Recharges/index.js